module.exports = __webpack_public_path__ + "static/media/myAccountBanner.52af13e3.png";